import { render, staticRenderFns } from "./RoundStatus.vue?vue&type=template&id=70dad740&"
import script from "./RoundStatus.vue?vue&type=script&lang=js&"
export * from "./RoundStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports